import { MaintenanceInfo } from '../maintenance-types';
import MaintenanceStore from '../stores/MaintenanceStore';

export const setMaintenanceInfo = (info: MaintenanceInfo) => {
  MaintenanceStore.info = info;
};

export const setBannerDismissed = () => {
  MaintenanceStore.bannerDismissed = true;
};
